import { useEffect, useState } from 'react';
import { recordQuestionScore, storedTotalScore } from './storage';

export const useStudentScore = (joinCode, state, selectedOption) => {
    const [total, setTotal] = useState(() => storedTotalScore(joinCode));

    const revealed = state?.status === 'revealed';
    const answered = selectedOption !== null;
    const ord = state?.question?.ord;
    const earnedPoints = revealed && selectedOption === state.question.correct ? state.question.points : 0;

    // An unanswered reveal is left unrecorded rather than recorded as a zero: a
    // reload empties `selectedOption`, and a zero written then would stick.
    useEffect(() => {
        if (!revealed || !answered || ord === undefined) return;
        setTotal(recordQuestionScore(joinCode, ord, earnedPoints));
    }, [joinCode, revealed, answered, ord, earnedPoints]);

    return { earnedPoints, totalScore: total };
};
